export enum RemoteCommandType {
  LOAD_SCRIPT = 1,
  START_SCRIPT = 2,
  STOP_SCRIPT = 3,
  START_APP = 4,
  STOP_APP = 5,
  VQUAD_AUTOTRAFFIC_START_CONTINUE = 100,
  VQUAD_AUTOTRAFFIC_START_ONCE = 101,
  VQUAD_AUTOTRAFFIC_STOP = 102,
  VQUAD_AUTOTRAFFIC_LOAD = 103,
  VQUAD_UPLOAD_SCRIPT = 104,
  VQUAD_DOWNLOAD_SCRIPT = 105,
  VQUAD_LOAD_MASTER_CONFIGURATION = 106,
  CC_UPLOADSUPERSCRIPT = 300,
  CC_DOWNLOADSUPERSCRIPT = 301,
  CC_DOWNLOADSITESCRIPT = 302,
  PLACE_CALL = 6,
  ANSWER_CALL = 7,
  DISCONNECT_CALL = 8,
  DELETE_CONFIG = 9,
  SAVE_CONFIG = 10,
  LOAD_CCSCRIPT = 11,
  VQUAD_NEW_SCHEDULE = 12,
  CUSTOM_REPORT_INI = 13,
  PAIRED_BT = 18
}

export enum PipeCmd {
  None = 0,
  SetNetworkInfo,
  ExitAFT,

  // Call Control
  PlaceCallByDeviceID,          // DeviceID or CalledNumber
  AnswerCallByDeviceID,         // DeviceID
  DisconnectCallByDeviceID,     // DeviceID

  // Configuration
  LoadConfigurationByID,        // DeviceID or Config_Type or Config_Name
  DeleteConfigurationByID,      // DeviceID or Config_Type or Config_Name
  SaveConfigurationByID,        // DeviceID or Config_Type or Config_Name

  LoadCCScriptByDeviceID,       // DeviceID or Script_Name
  StartStopCCScriptByDeviceID,  // DeviceID or Start_Stop

  // Start/Stop Traffic
  StartStopTrafficByDeviceID,   // DeviceID or Start_Stop or Traffic_type or traffic_parms

  // Schedule
  NewScheduleReady,             // Path (Schedule File Path)

  // Trigger GrabFileRequest
  SendFile,                     // LocalFile(CentralDB PC) or RemoteFile(VQuad PC)

  // Load and Start FIle monitor
  StartFileMonitor,             // Primary^Sec1^Sec2^Sec3 IPs, C:\VQT_Degraded, not Delete, *.pcm/ *.wav/ *.*
  StopFileMonitor,

  //Send Webview Custom reports and Main FIlters list to VQuad Custom reports screen for Scheduelr
  CustomReportIni,
  //DeviceID|CallTypeOpt(Orig/Term)|strCallType
  QueryCallType,
  //Get Bluetooth paired list
  PairedBT
}

export enum AppInfoType {
  VQUAD_SCRIPT = 100,
  VQUAD_TRAFFIC = 101,
  VQUAD_LOADMASTERCONFIGURATION = 102,
  VQT_SCRIPT = 200,
  CC_SCRIPT_SUPER = 300,
  CC_SCRIPT_SITE = 301
}

export enum CCScriptType {
  Site = 6,
  Super = 7,
  Scheduler = 8
}

export enum CommandType {
  VQUAD = 10100,
  VQT = 10200,
  CC = 10300,
  FILEMONITOR = 10400
}
